import { Link } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import { fmtDate } from "./StatusBadge";

export const ExpiringComps = ({ items }) => (
  <section className="rounded-2xl border bg-card p-4 shadow-soft" data-testid="admin-expiring-comps">
    <h2 className="flex items-center gap-2 text-sm font-semibold text-foreground"><CalendarClock className="h-4 w-4" />Comps ending in the next 7 days</h2>
    {items.length === 0 ? <p className="mt-2 text-sm text-muted-foreground" data-testid="admin-expiring-empty">None.</p> : (
      <ul className="mt-3 divide-y">
        {items.map((c) => (
          <li key={c.id} className="flex items-center justify-between gap-3 py-2.5 text-sm">
            <Link to={`/admin/accounts/${c.id}`} className="min-w-0 truncate font-medium text-foreground hover:underline" data-testid={`admin-expiring-${c.id}`}>
              {c.company_name} <span className="text-muted-foreground">· {c.email}</span>
            </Link>
            <span className="shrink-0 text-muted-foreground">{fmtDate(c.comped_until)}</span>
          </li>
        ))}
      </ul>
    )}
  </section>
);
